import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SideDrawer.module.css';

function SideDrawer({ open, onClose }) {
  return (
    <>
      <div
        className={`${styles.backdrop} ${open ? styles.show : ''}`}
        onClick={onClose}
      />

      <aside className={`${styles.drawer} ${open ? styles.open : ''}`}>
        {/* Drawer header */}
        <div className={styles.drawerHeader}>
          <button
            className={`${styles.hamburger} ${styles.open}`}
            onClick={onClose}
            aria-label="Close menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        <nav className={styles.nav}>
          <Link to="/" onClick={onClose}>HOME</Link>
        </nav>
        <button
            className={styles.getInvolved}
            onClick={() =>
                (window.location.href =
                'mailto:ogdenResistance@gmail.com?subject=Get%20Involved&body=I%20want%20to%20get%20involved!')
            }
        >
            GET INVOLVED
        </button>
        <button
            className={styles.getInvolved}
            onClick={() => {
              window.location.href = "https://linktr.ee/weberfridge";
            }}
        >
            DONATE TO WEBER FRIDGE
        </button>

      </aside>
    </>
  );
}

export default SideDrawer;
